import { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { PdpRespStorytellingText } from './PdpRespStorytellingText';
import { PdpSharedStorytellingMainMedia } from '../PdpSharedStorytellingComponents/PdpSharedStorytellingMainMedia';
import { PdpSharedStorytellingShopAllLink } from '../PdpSharedStorytellingComponents/PdpSharedStorytellingShopAllLink';

import { getSrcsetString } from 'dibs-image-utils/exports/srcSet';

import { PdpRespStorytellingTab_storyTellingTab$data } from './__generated__/PdpRespStorytellingTab_storyTellingTab.graphql';

import classnames from 'classnames';

import styles from './PdpRespStorytellingModule.scss';

type Props = {
    storyTellingTab: PdpRespStorytellingTab_storyTellingTab$data;
    clearBackground: boolean;
    wrapperClass?: string;
    showExpandingArea?: boolean;
    showHeader?: boolean;
    dataTn?: string;
};

const PdpRespStorytellingTabComponent: FC<Props> = ({
    storyTellingTab,
    clearBackground,
    wrapperClass,
    showExpandingArea,
    showHeader = true,
    dataTn,
}) => {
    const { smallImage, mainImage, mainVideo } = storyTellingTab;
    const largeImageAndText = mainImage || mainVideo;

    function getColumnClass(columnClass: string): string {
        return classnames(columnClass, {
            [styles.largeImageAndText]: largeImageAndText,
        });
    }

    return (
        <div
            className={classnames(styles.tabContainer, wrapperClass, {
                [styles.clearBackground]: !!clearBackground,
            })}
            data-tn={dataTn}
        >
            <div className={styles.innerTabContainer}>
                {smallImage && (
                    <div className={`${styles.imageColumn} ${styles.smallImageCol}`}>
                        <div className={styles.smallImageWrapper}>
                            <img
                                className={styles.smallImage}
                                src={smallImage}
                                srcSet={getSrcsetString(smallImage)}
                                sizes="20vw"
                                alt=""
                            />
                        </div>
                        <PdpSharedStorytellingShopAllLink storyTellingTab={storyTellingTab} />
                    </div>
                )}
                <div className={styles.textCol}>
                    <PdpRespStorytellingText
                        storyTellingTab={storyTellingTab}
                        showExpandingArea={showExpandingArea}
                        showHeader={showHeader}
                    />
                </div>
                {(mainImage || mainVideo) && (
                    <div className={`${styles.imageColumn} ${getColumnClass(styles.mainImageCol)}`}>
                        <PdpSharedStorytellingMainMedia storyTellingTab={storyTellingTab} />
                    </div>
                )}
            </div>
        </div>
    );
};

export const PdpRespStorytellingTab = createFragmentContainer(PdpRespStorytellingTabComponent, {
    storyTellingTab: graphql`
        fragment PdpRespStorytellingTab_storyTellingTab on StoryTellingTab {
            ...PdpRespStorytellingText_storyTellingTab
            ...PdpSharedStorytellingMainMedia_storyTellingTab
            ...PdpSharedStorytellingShopAllLink_storyTellingTab
            smallImage
            mainImage
            mainVideo
        }
    `,
});
